import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-4" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "+", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "col-8" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Prefisso",
              text: "Prefisso"
            })
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.prefix) = $event)),
            class: "form-control"
          }, [
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prefixList, (item, i) => {
              return (_openBlock(), _createElementBlock("option", {
                key: i,
                value: item.prefix
              }, _toDisplayString(item.country) + " " + _toDisplayString(item.prefix), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.localValue.prefix]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Numero di telefono",
              text: "Numero di telefono"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: _ctx.$localizationService.GetLocalizedValue('Inserisci il tuo numero', 'Inserisci il tuo numero'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.number) = $event))
          }, null, 8, _hoisted_8), [
            [_vModelText, _ctx.localValue.number]
          ])
        ])
      ])
    ])
  ]))
}